import request from './axios.config'
import { filterHiddenTenants } from '@/apis/modules/npgw/cms/tenant_config'

/**
 * 获取网站列表
 * post
 * **/
export const listTenantByProductGroupId = (params) => {
    return request({
        url: `/npgw/common-layer/userTenantPermission/listTenantByProductGroupId`,
        method: 'get',
        params
    })
}

/**
 * 获取网站列表（根据用户权限获取仅授权的网站）
 * @param {{ userCode: string, isSuper: string }} params 
 */
export const listTenantByTenantIdAndUserCode = (params) => {
    return request({
        url: `/npgw/common-layer/userTenantPermission/listTenantByTenantIdAndUserCode`,
        method: 'get',
        params
    }).then(filterHiddenTenants)
}

/**
 * 获取网站权限
 * @param {{ userCode: string, isSuper: string }} params 
 */
export const listTenantByUserCodeAndPermissionCode = (params) => {
    return request({
        url: `/npgw/common-layer/userTenantPermission/listTenantByUserCodeAndPermissionCode`,
        method: 'get',
        params
    }).then(filterHiddenTenants)
}

/**
 * 获取网站下的菜单列表
 * post
 * **/
export const listTenantAllMenuByTenantIdAndProductCode = (params) => {
    return request({
        url: `/npgw/common-layer/userMenuPermission/listTenantAllMenuByTenantIdAndProductCode`,
        method: 'get',
        params
    })
}

/**
 * 获取集团主站下的特殊应用
 * post
 * **/
export const listProductMenuByProductCode = (params) => {
    return request({
        url: `/npgw/common-layer/userMenuPermission/listProductMenuByProductCode?productCode=digitportal-group-common`,
        method: 'get',
        params
    })
}

/**
 * 保存/编辑角色 数字门户
 * post
 * **/
export const saveOrUpdateRolePermission = (data, logObj) => {
    return request({
        url: `/npgw/common-layer/userRolePermission/saveOrUpdateRolePermission`,
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '子站账号权限',
        },
    })
}

/**
 * 判断角色是否可删除
 * post
 * **/
export const isExistUserByRoleCode = (params) => {
    return request({
        url: `/npgw/common-layer/userRolePermission/isExistUserByRoleCode`,
        method: 'get',
        params
    })
}

/**
 * 删除角色
 * post
 * **/
export const delRoleByRoleCode = (data, logObj) => {
    return request({
        url: `/npgw/common-layer/userRolePermission/delRoleByRoleCode?roleCode=${data.roleCode}`,
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '子站账号权限',
            operModule: '删除子账号角色',
        },
    })
}

/**
 * 根据角色code 获取角色详情
 * post
 * **/
export const getRoleByRoleCode = (params) => {
    return request({
        url: `/npgw/common-layer/userRolePermission/getRoleByRoleCode`,
        method: 'get',
        params
    })
}

/**
 * 给子账号授权角色
 * post
 * **/
export const saveOrDelUserRole = (data,memberCode, params) => {
    return request({
        url: `/npgw/common-layer/userRolePermission/saveOrDelUserRole/${memberCode}`,
        method: 'post',
        data,
        params
    })
}


// 300子账号信息保存
export const updateSubMemberTelAndMail = (params) => {
    return request({
        url: `/npgw/mwebapi/api-portal/api/member/updateSubMemberTelAndMail`,
        method: 'get',
        params
    })
}

// get300子账号信息
export const findOneByMemerCode = (params) => {
    return request({
        url: `/npgw/mwebapi/api-portal/api/member/findOneByMemerCode`,
        method: 'get',
        params
    })
}
// 300子账号修改密码
export const updateSubMemberP = (data) => {
    return request({
        url: `/npgw/mwebapi/api-portal/api/member/updateSubMemberP`,
        method: 'post',
        data
    })
}